var WEEK = 'week',
  WEEKPICKER = 'WeekPicker';
export { WEEK, WEEKPICKER };
var MONTH = 'month',
  MONTHPICKER = 'MonthPicker';
export { MONTH, MONTHPICKER };
var YEAR = 'year',
  YEARPICKER = 'YearPicker';
export { YEAR, YEARPICKER };
var QUARTER = 'quarter',
  QUARTERPICKER = 'QuarterPicker';
export { QUARTER, QUARTERPICKER };
var TIME = 'time',
  TIMEPICKER = 'TimePicker';
export { TIME, TIMEPICKER };